module.exports = __webpack_public_path__ + "img/ar.ac9cbc65.png";